
import { Component, InjectReactive, Vue } from 'vue-property-decorator'

import OrderHistory from '@/components/OrderHistory.vue';
import BasketModule from '@/store/modules/basket';

@Component({
  components: {
    OrderHistory
  },
  metaInfo: {
    title: 'Cousins Subs',
    titleTemplate: '%s - Order - Order Confirmation'
  }
})
export default class OrderConfirmation extends Vue {
  @InjectReactive('progressRef') progressRef: any;

  mounted() {
    this.$scrollTo(this.progressRef as Element);
  }

  get orderModel() {
    return BasketModule.orderModel || {};
  }

  get firstName() {
    return BasketModule.customerFirstName;
  }

  get basketId() {
    return BasketModule.placedOrderBasketId;
  }
}
